/*
 * @Description: 头部导航
 * @Author: yy
 * @LastEditors: yy
 * @Date: 2019-02-11 14:37:10
 * @LastEditTime: 2020-08-18 10:16:49
 */


import React from 'react';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
// @ts-ignore
import s from './Navigation.css';
import Link from '../Link';

class Navigation extends React.Component {

  shouldComponentUpdate(nextProps) {
    let ss = true
    if (nextProps.navShow == this.props.navShow) {
      ss = false
    }
    return ss
  }

  render() {
    const { hasMarginRight } = this.props
    return (
      <div className={s.root}>
        <div className={this.props.navShow ? s.native : cx(s.native, s.hide)}>
          <ul className={s.nav} style={{ marginRight: this.props.hasMarginRight ? '20px' : null }}>
            {/* <li className={s.navItem}>
              <a target="_blank" href='/cms' >品牌管理</a>
            </li> */}
            <li className={s.navItem}>
              <Link to='/new-cms' >后台</Link>
            </li>
            <li className={s.navItem}>
              <Link to='/restore'>恢复文章界面</Link>
            </li>
            <li className={s.navItem}>
              <Link to="/" >首页</Link>
            </li>
            <li className={cx(s.navItem, s.posi)} onMouseEnter={this.props.showSub} onMouseLeave={this.props.hideSub} >
              <Link to="/top100">DBRank100</Link>
              <ul className={s.subMune}>
                <li className={s.subItem}>
                  <Link to='/top100'>总 榜</Link>
                </li>
                <li className={s.subItem}>
                  <Link to='/industry'>行业榜</Link>
                </li>
                <li className={s.subItem}>
                  <Link to='/platform'>平台榜</Link>
                </li>
                <li className={s.subItem}>
                  <Link to='/geo'>地理榜</Link>
                </li>
              </ul>


              {hasMarginRight ?
                <ul className={s.subMune}>
                  <li className={s.subItem}>
                    <Link to='/top100'>总 榜</Link>
                  </li>
                  <li className={s.subItem}>
                    <Link to='/industry'>行业榜</Link>
                  </li>
                  <li className={s.subItem}>
                    <Link to='/platform'>平台榜</Link>
                  </li>
                  <li className={s.subItem}>
                    <Link to='/geo'>地理榜</Link>
                  </li>
                </ul>
                : null}
            </li>
            <li className={s.navItem}>
              <Link to="/dashboard">品牌详情</Link>
            </li>
            <li className={s.navItem}>
              <Link to="/customChart/IndustryContent">常用图表</Link>
              {/* <Link to="/solution">解决方案</Link> */}
            </li>
            <li className={s.navItem}>
              <a href="/digitalAssets/setRedisInfo" target="_blank">已完成文章修改</a>
            </li>
            <li className={s.navItem}>
              <Link to="/aboutus">关于DBRank</Link>
            </li>
          </ul>
        </div>
      </div>
    )
  }
}

export default withStyles(s)(Navigation);



// WEBPACK FOOTER //
// src/components/Navigation/Navigation.js